import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

import { Filter } from '../../shared/filter';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Ship } from '../../_models/ship';
import { ShipService } from '../../_services/ship.service';

import { IncidenceFilter } from '../../_models/control-item';

@Component({
  selector: 'app-incidence-filter',
  templateUrl: './incidence-filter.component.html',
  styleUrls: ['./incidence-filter.component.sass'],
})
export class IncidenceFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: IncidenceFilter;

  ships: SelectItem[] = [];
  selectedShips: Ship[];
  startDate: Date;
  endDate: Date;

  constructor(private fb: FormBuilder, private shipService: ShipService, private router: Router, private httpErrorHandler: HttpErrorHandler) {
    super();
    this.form = fb.group({
      code: [''],
      ship: [''],
      start_date: [''],
      end_date: [''],
      show_ignored: false,
    });
  }

  ngOnInit() {
    this.filter = new IncidenceFilter(this.filterParams);
    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }
    this.getShips();
  }

  getShips() {
    this.shipService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ship);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  onSubmit() {
    this.filter.start_date = '';
    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    }

    this.filter.end_date = '';
    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    }

    this.filter.ship = [];
    if (this.selectedShips) {
      this.filter.ship = this.selectedShips;
    }

    if (this.filterParams['o'] !== undefined) {
      this.filter['o'] = this.filterParams['o'];
    }

    this.router.navigate(['/incidences', IncidenceFilter.serializeRouterParams(this.filter)]);
  }
}



// WEBPACK FOOTER //
// ./src/app/incidences/incidence-filter/incidence-filter.component.ts